'use strict';
import ProviderManager from '../provider/providerManager';
import {getFullDate} from './dateUtils';
import {getRecaptchaToken} from '../utilities/recaptcha/recaptcha';

export const openWorkOrder = async (workOrderParams) => {
  const token = await getRecaptchaToken('openWorkOrder');
  if (token == undefined || token == null || token == '') {
    return;
  }

  const fullDate = getFullDate();

  /*
  let workOrderParams = {
    fuType: '',
    fuText: '',
    ban: '',
    fullName: '',
    identity: '',
    contactNumber: '',
    payment4DigitNumber: '',
    errorDesc: '',
    screenName: '',
    timeSlot: ''
  }
  */

  try {
    const request = {
      Token: token,
      ApplicationId: 'CELLCOM_WEB_SITE',
      FuSource: 'V',
      ErrorCode: workOrderParams.errorCode,
      FuType: workOrderParams.fuType,
      FuText: workOrderParams.fuText,
      OperatorId: 'SCARE',
      FuBan: workOrderParams.ban,
      ExternalIdNum: null,
      ListRow: [
        {
          ParamCode: 'Z10411',
          ParamValue: workOrderParams.fullName,
        },
        {
          ParamCode: 'Z10412',
          ParamValue: workOrderParams.identity,
        },
        {
          ParamCode: 'Z10413',
          ParamValue: workOrderParams.ban,
        },
        {
          ParamCode: 'Z10414',
          ParamValue: workOrderParams.contactNumber,
        },
        {
          ParamCode: 'Z10415',
          ParamValue: workOrderParams.payment4DigitNumber,
        },
        {
          ParamCode: 'Z10416',
          ParamValue: workOrderParams.errorDesc,
        },
        {
          ParamCode: 'Z10417',
          ParamValue: fullDate,
        },
        {
          ParamCode: 'Z10418',
          ParamValue: workOrderParams.screenName,
        },
        {
          ParamCode: 'Z10419',
          ParamValue: workOrderParams.timeSlot,
        },
      ],
    };

    request.ListRow = request.ListRow.filter((x) => x.ParamValue.trim() != '');

    console.info('openWorkOrder - request', request);
    const result = await ProviderManager.getProviderData('openWorkOrder', request);
    return result.Body.isSuccess;
  } catch (error) {
    console.error('openWorkOrder : ', error);
    return false;
  }
};

export const openWorkOrderVolte = async (workOrderParams) => {
  const token = await getRecaptchaToken('openWorkOrder');
  if (token == undefined || token == null || token == '') {
    return;
  }
  try {
    const request = {
      Token: token,
      ApplicationId: 'CELLCOM_WEB_SITE',
      FuSource: 'V',
      FuType: workOrderParams.isDynamica ? 'DN01' : 'YAR4',
      FuText: 'יש לחזור ללקוח.ה לטובת שדרוג מכשיר',
      OperatorId: workOrderParams.isDynamica ? 'SCARE' : 'shlomimy',
      FuBan: '1',
      ExternalIdNum: null,
      ListRow: [
        {
          ParamCode: workOrderParams.isDynamica ? 'Z152473' : 'Z10411',
          ParamValue: workOrderParams.fullName,
        },
        {
          ParamCode: workOrderParams.isDynamica ? 'Z152474' : 'P705',
          ParamValue: workOrderParams.contactNumber,
        },
      ],
    };

    request.ListRow = request.ListRow.filter((x) => x.ParamValue.trim() != '');

    console.info('openWorkOrder - request', request);
    const result = await ProviderManager.getProviderData('openWorkOrderVolte', request);
    return result.Body.isSuccess;
  } catch (error) {
    console.error('openWorkOrder : ', error);
    return false;
  }
};

export const callOpenWorkOrderForSale = async (state) => {
  const flowType = state.flowType == 'newCustomer' ? 'לקוח חדש' : 'לקוח קיים';

  let fuType = '';
  let saleTypeHeb = '';
  let fuText = '';
  switch (state.saleType) {
    case 'cellular':
      fuType = 'NIR1';
      saleTypeHeb = 'סלולר';
      const existNumbers = state.productsInfo.selectedProducts
        ?.reduce((a, x) => (x.isExistPhone == true && a.push(x.existPhone), a), [])
        ?.join();
      const newNumbers = state.productsInfo.selectedProducts
        ?.reduce((a, x) => (x.isExistPhone == false && a.push(x.newPhone), a), [])
        ?.join();
      fuText =
        'כשלון בתהליך מכר ' +
        saleTypeHeb +
        ' ,  ' +
        flowType +
        ' : הלקוח ביקש תוכנית ' +
        state.epiServer.configuration.welcomeText +
        (existNumbers != '' ? ' , מספרים לניוד : ' + existNumbers : '') +
        (newNumbers != '' ? ', מספרים חדשים : ' + newNumbers : '');
      break;
    case 'tv':
      fuType = 'NIR2';
      saleTypeHeb = 'TV';
      const vasList = state.vasList?.reduce((a, x) => (a.push(x.title), a), [])?.join();
      fuText =
        'כשלון בתהליך מכר ' +
        saleTypeHeb +
        ' ,  הלקוח בחר בתוכנית : ' +
        state.epiServer.configuration.welcomeText +
        (state.productsInfo.selectedProducts?.length > 0 ? ' , ' + state.productsInfo.selectedProducts.length + ' ממירים ' : '') +
        (vasList != '' ? ', ערוצים : ' + vasList : '') +
        '.';
      break;
    case 'internet':
      fuType = 'NIR3';
      saleTypeHeb = 'סיבים';
      const address =
        state.selectedAddress?.streetName && state.selectedAddress?.streetName != ''
          ? state.selectedAddress.streetName +
            ' ' +
            state.selectedAddress.home +
            ' ' +
            state.selectedAddress.cityName +
            ' ' +
            (state.selectedAddress.apartment != '' ? 'דירה ' + state.selectedAddress.apartment : '')
          : '';
      const isIBCTechnician = !state.isCustomerConnectedToIbc && state.selectedAddress.infrastructure?.tashtitType == 'IBC';
      fuText =
        ' כשלון בתהליך מכר ' +
        saleTypeHeb +
        ' , ' +
        state.epiServer.configuration.welcomeText +
        ' ,' +
        (address != '' ? ' כתובת השירות: ' + address + ' , ' : '') +
        (state.technicianArrivalTime.arrivalTime
          ? ' בחר מועד לטכנאי ' + (isIBCTechnician ? ' IBC' : '') + state.technicianArrivalTime.arrivalTime + ' , '
          : '') +
        (state.isMeshUpgrade ? ' ביקש להוסיף סופר וויפי ' : '');
      break;
    case 'app':
      fuType = 'NIR2';
      saleTypeHeb = 'אפליקציה';
      fuText = 'כשלון בתהליך מכר ' + saleTypeHeb + ' . ';
      break;
  }

  const fullName = (state.personalInfo.firstName ?? '') + ' ' + (state.personalInfo.lastName ?? '');
  const ban = state.personalInfo.ban != null && state.personalInfo.ban != '' ? state.personalInfo.ban : '1';

  let workOrderParams = {
    fuType: fuType,
    fuText: fuText,
    ban: ban,
    errorCode: state.error.id,
    fullName: fullName,
    identity: state.otpIdentity ?? '',
    contactNumber: state.otpPhone,
    payment4DigitNumber: '',
    errorDesc: 'קוד שגיאה ' + state.error.id,
    screenName: state.page,
    timeSlot: state.technicianArrivalTime.arrivalTime ?? '',
  };

  return await openWorkOrder(workOrderParams);
};

export const callOpenWorkOrderForSaleJet = async (state) => {
  const flowType = state.flowType == 'newCustomer' ? 'לקוח חדש' : 'לקוח קיים';
  const mainVasList = getPremiumPackageCostumerAdd(state.saleCatalog);
  const converters = state.saleCatalog.converters?.filter((converter) => converter.action.toUpperCase() == 'ADD')?.length;
  const address = state.addressPage?.selectedAddress;
  const selectedEntry = state.addressPage?.selectedEntry;
  const bans = state.userAddressPage?.selectedAddress?.additionalInfo?.banId
    ? [state.userAddressPage?.selectedAddress?.additionalInfo.banId]
    : [];
  const downloadSpeed = state.selectedPackage?.downloadSpeed;
  const uploadSpeed = state.selectedPackage?.uploadSpeed;
  const isSelectedCellcomRouter = state.selectedPackage?.isSelectedCellcomRouter;
  const defaultRouterName =
    state.selectedPackage?.selectedRouterName?.toUpperCase() === 'NATAVT' ? 'נתב פרטי' : state.selectedPackage?.selectedRouterName;
  const cellcomRouterName = state.saleCatalog?.routers?.length > 0 ? state.saleCatalog?.routers[0]?.localizedName : '';

  let selectedRouterName = '';
  if (state.saleType.toUpperCase() !== 'TV') {
    selectedRouterName = isSelectedCellcomRouter ? cellcomRouterName : defaultRouterName;
  }

  let request = {
    orderType: 'SALE_JET',
    identityNumber: state.personalInfo.identity,
    externalIdNum: '', //CONSUMER ID - Get from Backend
    firstName: state.personalInfo.firstName,
    lastName: state.personalInfo.lastName,
    errorCode: state.errorPage.id,
    errorDescription: state.errorPage.description,
    subscriber: state.personalInfo.subscriberNo,
    banList: bans,
    psidList: [],
    saleJet: {
      saleType: state.saleType,
      flowType: flowType,
      pageName: state.page,
      technicianDate: state.technician.selectedTechnicianTimeDisplay ?? '',
      payment4DigitNumber: state.paymentInfo?.Credit4Digits ?? '',
      vases: mainVasList,
      convertersCount: converters,
      offerName: state.saleCatalog.offerName,
      offerID: state.saleCatalog.offerId,
      selectedRouterName: selectedRouterName ?? '',
      downloadSpeed: downloadSpeed ?? '',
      uploadSpeed: uploadSpeed ?? '',
      isSelectedSuperWifi: state.isSelectedSuperWifi,
      addressDetails: {
        cityName: address.cityName ?? '',
        streetName: address.streetName ?? '',
        cityCode: address.cityCode ?? '',
        streetCode: address.streetCode ?? '',
        citySemel: '',
        streetSemel: '',
        homeNum: address.home ?? '',
        apartment: address.apartment ?? '',
        floor: address.floor ?? '',
        zipCode: address.zipCode ?? '',
        infrastructure: selectedEntry.infrastructure ?? '',
        entry: address.entry ?? '',
      },
    },
  };

  const result = await ProviderManager.getProviderData('createWorkOrder', request);
  return result?.Body;
};

function getPremiumPackageCostumerAdd(saleCatalog) {
  const premiumPackageList = [];
  saleCatalog.premiumPackages?.map((item) => {
    if (item.isPremiumPackagesWorld) {
      item.premiumPackages.map((item) => {
        if (item.action.toUpperCase() == 'ADD') {
          premiumPackageList.push(item.billDescription);
        }
      });
    } else if (item.action?.toUpperCase() == 'ADD') {
      premiumPackageList.push(item.billDescription);
    } else if (item.vasList?.length > 0) {
      item.vasList.map((item) => {
        if (item.action?.toUpperCase() == 'ADD') {
          premiumPackageList.push(item.billDescription);
        }
      });
    }
  });

  return premiumPackageList?.join();
}

export const callOpenWorkOrderForEnergySaleJet = async (state) => {
  const bans = state.summaryDetails?.banId ? [state.summaryDetails?.banId] : [];

  let errorDescription = state.errorPage.description;
  if (state.isDisplayPopupForHelp) {
    errorDescription = 'משתמש ביקש שנציג יחזור אליו מתוך תהליך המכר הדיגיטלי';
  }

  var hasSmartMeter = !!state?.iecResponse?.serviceMigratable;

  let request = {
    orderType: 'ENERGY_SALE_JET',
    identityNumber: state.otpDetails.identityNumber,
    externalIdNum: '', //CONSUMER ID - Get from Backend
    firstName: state.personalInfo.firstName,
    lastName: state.personalInfo.lastName,
    errorCode: '',
    errorDescription: errorDescription,
    subscriber: state.otpDetails.phoneNumber,
    banList: bans,
    psidList: [],
    energySaleJet: {
      OfferID: state.selectedPackage.offerId,
      offerName: state.selectedPackage.title,
      creditCardToken: state.paymentInfo.CCToken,
      creditCardType: state.paymentInfo.CCType,
      email: state.personalInfo.email,
      isSignPowerOfAttorney: state.signatureInfo.isSigned,
      isReceivingAd: state.personalInfo.isReceivingAd,
      hasSmartMeter: hasSmartMeter,
      meterNumber: state.iecResponse.currentConsumption,
      contractNumber: state.iecResponse.contractId,
      addressDetails: {
        cityName: state.userAddress.cityName ?? '',
        streetName: state.userAddress.streetName ?? '',
        cityCode: state.userAddress.cityCode ?? '',
        streetCode: state.userAddress.streetCode ?? '',
        homeNum: state.userAddress.home ?? '',
        apartment: state.userAddress.apartment ?? '',
        zipCode: state.userAddress.zipCode ?? '',
      },
    },
  };

  const result = await ProviderManager.getProviderData('createWorkOrder', request);
  return result?.Body;
};

export const openWorkOrderForServiceAppointment = async (state) => {
  const userDetails = state.authentication?.loginData?.userDetails;

  let request = {
    orderType: 'SERVICE_APPOINTMENT_SCHEDULER',
    identityNumber: userDetails?.IDNumber ?? '',
    externalIdNum: '', //CONSUMER ID - Get from Backend
    firstName: userDetails?.firstName ?? '',
    lastName: userDetails?.lastName ?? '',
    errorCode: '',
    errorDescription: '',
    subscriber: state.phoneNumberForCallBack ?? '',
    banList: [],
    psidList: [],
  };

  const result = await ProviderManager.getProviderData('createWorkOrder', request);
  return result?.Body;
};
